// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components----Services-module---root---1Y0z0","item":"src-components----Services-module---item---4zvsa","link":"src-components----Services-module---link---2wmXe","image":"src-components----Services-module---image---MpVj-","title":"src-components----Services-module---title---2rZFt","description":"src-components----Services-module---description---1fUFK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Services.module.scss
// module id = ./src/components/Services.module.scss
// module chunks = 10013748475682